import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useMasterGroups from '@/hooks/data/useMasterGroups';
import MasterGroupContext, { IMasterGroupContext } from '@/contexts/data/MasterGroupContext';
import IsLoading from '@/components/layouts/IsLoading';
import { useMatch, useParams } from 'react-router-dom';
import MasterGroupsContext from '@/contexts/data/MasterGroupsContext';
import InstitutionContext from '@/contexts/data/InstitutionContext';
import CoordinatingGroupContext from '@/contexts/data/CoordinatingGroupContext';


export interface IMasterGroupProviderProps {
}

export const MasterGroupProvider: FC<PropsWithChildren<IMasterGroupProviderProps>> = ({ children }) => {
    const masterGroups = useContext(MasterGroupsContext);
    const institution = useContext(InstitutionContext);
    const coordinatingGroup = useContext(CoordinatingGroupContext);

    const masterGroupId = institution.data?.masterGroupId ?? coordinatingGroup.data?.masterGroupId;
    const masterGroupCode = useParams()?.masterGroupCode;

    const masterGroup  = useMemo(() => {
        if (!masterGroupId && !masterGroupCode) {
            return {
                data: undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as IMasterGroupContext;
        }

        if (!!masterGroupCode) {
            return {
                data: masterGroups.data?.find(x => x.code === masterGroupCode),
                error: masterGroups.error,
                loading: masterGroups.loading,
                validating: masterGroups.validating,
                refresh: async () => {
                    const newData = await masterGroups.refresh();
    
                    return newData?.find(x => x.code === masterGroupCode);
                },
            } as IMasterGroupContext
        }

        return {
            data: masterGroups.data?.find(x => x.id === masterGroupId),
            error: masterGroups.error,
            loading: masterGroups.loading,
            validating: masterGroups.validating,
            refresh: async () => {
                const newData = await masterGroups.refresh();

                return newData?.find(x => x.id === masterGroupId);
            },
        } as IMasterGroupContext
    }, [masterGroups, masterGroupId, masterGroupCode]);

    return (

        <MasterGroupContext.Provider value={masterGroup}>
            <IsLoading name="master-group" loading={masterGroup.loading} validating={masterGroup.validating}/>
            {children}
        </MasterGroupContext.Provider>
    );
}

export default MasterGroupProvider;
